import { FlexColumn, FormModal, SelectField } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { required } from '@ubeya/shared/utils/form';
import React, { useCallback, useContext, useMemo } from 'react';
import styled from 'styled-components';

const Container = styled(FlexColumn)`
  gap: 16px;
  padding: 16px 28px;
`;

const ContractAssignModal = ({ onClose, assignContract, accountContracts, activeContract }) => {
  const { t } = useContext(ConfigContext);

  const contractOptions = useMemo(
    () =>
      (accountContracts || [])
        .filter(({ isActive }) => {
          return isActive;
        })
        .map((contract) => ({
          label: contract.name,
          value: contract.id
        })),
    [accountContracts]
  );

  const onSubmit = useCallback(
    async (values) => {
      await assignContract({
        contractId: values.contractId
      });
      onClose();
    },
    [assignContract, onClose]
  );

  const modalTitle = activeContract ? 'contractTypes_reAssignContract' : 'contractTypes_assignContract';
  const confirmText = activeContract ? 'reAssign' : 'assign';

  return (
    <FormModal
      onSubmit={onSubmit}
      size="small"
      requiredWarningFooter={t('missingRequiredFields')}
      onClose={onClose}
      title={t(modalTitle)}
      confirmText={t(confirmText)}
      showConfirmButton={true}
      showCancelButton
      keepDirtyOnReinitialize
      disabledOnPristine={false}>
      <Container>
        {activeContract && <p>{t('contractTypes_changeContractPopup')}</p>}
        <SelectField
          name="contractId"
          title={t('contractTypes_Name')}
          validate={required}
          required
          usePortal
          isMulti={false}
          clearable={true}
          options={contractOptions}
        />
      </Container>
    </FormModal>
  );
};

export default ContractAssignModal;
